import React from "react";

// Shared sortable <th> for every admin table (Orders, Customers, ...) - a
// single definition instead of copy-pasting the same click handler and
// arrow indicator into each page, so sort styling can't drift between them.
const SortHeader = ({ label, field, sortBy, sortDir, onSort, className = "" }) => (
  <th
    className={`p-3 cursor-pointer select-none whitespace-nowrap hover:text-ink transition ${className}`}
    onClick={() => onSort(field)}
  >
    {label}
    {sortBy === field && <span className="ml-1">{sortDir === "asc" ? "↑" : "↓"}</span>}
  </th>
);

export default SortHeader;
